import Logo from "app/components/Icons/Logo";
import clsx from "clsx";
import React from "react";

interface Props {
  title: string;
  titleClassName?: string;
}

const TitleText: React.FC<Props> = ({ title, titleClassName }) => {
  return (
    <div className="flex flex-col items-center gap-[20px] mb-[56px]">
      <Logo size={72} />
      <h1
        className={clsx(
          "text-[40px] leading-[50px] font-semibold mb-4 text-center",
          titleClassName
        )}
      >
        {title}
      </h1>
    </div>
  );
};

export default TitleText;
